import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SiteLayout } from '../components/site/SiteLayout';
import { PageHero, SectionTitle } from '../components/site/PageHero';
import { ReasonsCarousel } from '../components/site/ReasonsCarousel';
import { STATES_FULL } from '../lib/site';

export default function About() {
  return (
    <SiteLayout testid="about-page">
      <PageHero
        testid="about-hero"
        eyebrow="About Zivae Financial"
        title="Plan with"
        accent="Confidence"
        intro="Navigating retirement can be complex, but with Zivae Financial on your side, you'll retire with confidence. As certified retirement plan consultants with extensive experience, we offer personalized, transparent, and ethical retirement consulting services."
        image="https://images.unsplash.com/photo-1758691031028-bf4928a640b4"
        imageAlt="Senior friends enjoying retirement"
      >
        <div className="space-y-5 text-slate-300 leading-relaxed max-w-2xl">
          <p>Our retirement consultants are licensed in <span className="font-semibold text-orange-300">19 states</span>: {STATES_FULL}.</p>
          <p>We serve clients both in person and virtually. We're passionate about educating our clients, ensuring you understand your options fully while providing thorough, expert guidance every step of the way.</p>
          <Link to="/contact" data-testid="about-contact-link" className="inline-flex items-center gap-2 rounded-full bg-orange-500 hover:bg-orange-600 px-7 py-4 font-semibold text-white">
            Talk to us <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </PageHero>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20" data-testid="about-reasons">
        <SectionTitle kicker="Why Zivae" title="5 great reasons to choose Zivae Financial" sub="Why families trust us with their retirement planning." />
        <ReasonsCarousel />
      </section>
    </SiteLayout>
  );
}
